<app-map-route
  *ngFor="let routeId of routeIds$ | async"
  [routeId]="routeId"
></app-map-route>
